module.exports = __webpack_public_path__ + "static/media/Jeremy Mogk.b074fff2.png";